import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 21404 34779"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#1c1b17;stroke-width:504.045}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970278445104">
        <path
          d="M10702 5500c-770 0-1395 625-1395 1394 0 771 625 1395 1395 1395s1395-624 1395-1395c0-769-625-1394-1395-1394zM10702 10748c-770 0-1395 624-1395 1394s625 1395 1395 1395 1395-625 1395-1395c-1-770-625-1394-1395-1394zM10702 15996c-770 0-1395 624-1395 1394s625 1394 1395 1394 1395-624 1395-1394c0-771-625-1394-1395-1394zM10702 252c-770 0-1395 625-1395 1394 0 770 625 1394 1395 1394s1395-624 1395-1394c-1-769-625-1394-1395-1394zM19757 21243c-770 0-1394 625-1394 1394 0 770 624 1395 1394 1395s1395-624 1395-1395c0-769-625-1394-1395-1394zM15230 21243c-770 0-1394 625-1394 1394 0 770 624 1395 1394 1395 769 0 1393-624 1393-1395 0-769-624-1394-1393-1394zM15230 26491c-770 0-1394 624-1394 1394s624 1394 1394 1394c769 0 1393-624 1393-1394 0-769-624-1394-1393-1394zM10702 21243c-770 0-1395 625-1395 1394 0 770 625 1395 1395 1395s1395-624 1395-1395c-1-769-625-1394-1395-1394zM10702 26491c-770 0-1395 624-1395 1394s625 1394 1395 1394 1395-624 1395-1394c-1-769-625-1394-1395-1394zM10702 31739c-770 0-1395 624-1395 1394s625 1394 1395 1394 1395-624 1395-1394c-1-770-625-1394-1395-1394zM6174 21243c-770 0-1395 625-1395 1394 0 770 624 1395 1395 1395 769 0 1394-624 1394-1395 0-769-624-1394-1394-1394zM6174 26491c-770 0-1395 624-1395 1394s624 1394 1395 1394c769 0 1394-624 1394-1394 0-769-624-1394-1394-1394zM1646 21243c-770 0-1394 625-1394 1394 0 770 624 1395 1394 1395s1394-624 1394-1395c0-769-624-1394-1394-1394z"
          className="fill stroke1s"
          style={{
            strokeWidth: 504.045,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
